import React, { useMemo, useCallback } from 'react'
import styles from './styles.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ButtonHeader = ({ buttonLink = '', buttonText = '', buttonIcon = '', isSecundaryButton = false, isExternalLink = true }) => {
  const iconMap = {
    external: 'external-link',
  }

  const openLink = (url, target) => {
    window.open(url, target, 'noopener,noreferrer')
  }

  const externalLink = useCallback(url => (isExternalLink ? openLink(url, '_blank') : openLink(url, '_self')), [isExternalLink])

  const styleButton = useMemo(() => (isSecundaryButton ? styles.secundaryButton : styles.primaryButton), [isSecundaryButton])

  return (
    <button
      className={`${styles.buttonHeader} ${styleButton}`}
      data-testid="header-button-link"
      onClick={() => externalLink(buttonLink)}
      id=""
    >
      {buttonText + ' '}

      {buttonIcon && <FontAwesomeIcon data-testid="header-button-icon" icon={['fal', iconMap[buttonIcon]]} />}
    </button>
  )
}

export default ButtonHeader
